import { apiFetch } from './client';

export const listDailyQuotes = (token) => apiFetch(token, '/daily-quotes');

export const uploadDailyQuote = (token, dayOfWeek, formData) =>
  apiFetch(token, `/daily-quotes/${dayOfWeek}`, { method: 'POST', body: formData });

export const deleteDailyQuote = (token, dayOfWeek) =>
  apiFetch(token, `/daily-quotes/${dayOfWeek}`, { method: 'DELETE' });
